import React, { useContext, useEffect } from 'react';

import TourSlidingScale from '../TourDetails/SlidingScale/TourSlidingScale';
import TourDetailsContext from '../TourDetails/TourDetailsContext';

interface Props {
  legacyTourId: string;
  tourName: string;
}

// The pricing tab names the tour from the tour page's context, so this page gives it one.
export default function NativeTourSlidingScale({ legacyTourId, tourName }: Props) {
  const { setTourDetails } = useContext(TourDetailsContext);
  // The old page's routes carry the tour as "tour-<id>", which svc-tour's form routes expect.
  const tourId = `tour-${legacyTourId}`;
  useEffect(() => {
    setTourDetails({ id: tourId, title: tourName });
  }, [tourId, tourName, setTourDetails]);

  return <TourSlidingScale tourId={tourId} />;
}
